import { render, staticRenderFns } from "./BaiJiuJiBindUser.vue?vue&type=template&id=1c969c78"
import script from "./BaiJiuJiBindUser.vue?vue&type=script&lang=js"
export * from "./BaiJiuJiBindUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports